import React from "react";
import { Box, Typography, CircularProgress } from "@mui/material";
import CustomDialog from "../../components-new/common/CustomDialog";

const scrollableBoxSx = {
  maxHeight: "60vh",
  overflowY: "scroll",
  pr: 1,
  "&::-webkit-scrollbar": {
    width: "8px",
    display: "block",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "8px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#888",
    borderRadius: "8px",
    "&:hover": {
      background: "#555",
    },
  },
};

const VisualAnalysisModal = ({ open, onClose, isLoading, data }) => {
  const issues = data?.steps?.[0]?.issues || [];

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      title="Visual Analysis Results"
      content={
        <Box sx={scrollableBoxSx}>
          <Box p={2}>
            {isLoading ? (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                gap={2}
                p={4}
              >
                <CircularProgress size={32} sx={{ color: "#2550D1" }} />
                <Typography color="#8089A8" fontSize="14px">
                  Loading analysis results...
                </Typography>
              </Box>
            ) : !issues.length ? (
              <Box display="flex" justifyContent="center" p={3}>
                <Typography color="#8089A8">
                  No design issues found for this step.
                </Typography>
              </Box>
            ) : (
              <Box display="flex" flexDirection="column" gap={2}>
                {issues.map((issue, idx) => (
                  <Box
                    key={idx}
                    sx={{
                      p: 2,
                      border: "1px solid #e2e8f0",
                      borderRadius: 2,
                      bgcolor: issue.found ? "#fff5f5" : "#f0fdf4",
                    }}
                  >
                    <Box display="flex" alignItems="flex-start" gap={1} mb={1}>
                      {issue.found ? (
                        <Typography sx={{ color: "#d32f2f", mt: "-2px" }}>✖</Typography>
                      ) : (
                        <Typography sx={{ color: "#2e7d32", mt: "-2px" }}>✔</Typography>
                      )}
                      <Typography sx={{ fontWeight: 600, color: "#334155" }}>
                        {issue.principle}
                      </Typography>
                    </Box>
                    <Typography sx={{ color: "#64748b", fontSize: "14px", ml: 3 }}>
                      {issue.description}
                    </Typography>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </Box>
      }
    />
  );
};

export default VisualAnalysisModal;
